import { helpCenterActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { HCCategoryIds } from '_constants'

const initialState = {
    selectedCategory: HCCategoryIds.REQUEST_HELP,
    locations: [],
};


export const reducer = createReducer(initialState, {
    [helpCenterActions.categoryChange]: (state, action) => {
        state.selectedCategory = action.payload.selectedCategory;
    },
    [helpCenterActions.locationSuccess]: (state, action) => {
        state.locations = action.payload.locations.result;
    },
})


